import { render, staticRenderFns } from "./videoOld.vue?vue&type=template&id=d9cd00f6&scoped=true&"
import script from "./videoOld.vue?vue&type=script&lang=js&"
export * from "./videoOld.vue?vue&type=script&lang=js&"
import style0 from "./videoOld.vue?vue&type=style&index=0&id=d9cd00f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cd00f6",
  null
  
)

export default component.exports